import { UserClaims } from "@/types/user.type";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AuthMixin extends Vue {
  userInfo(): UserClaims | undefined {
    const userInfo = sessionStorage.getItem("user-info");
    
    if (userInfo){
      return JSON.parse(userInfo) as UserClaims;
    }
  }

  get token(): string | undefined {
    const token = sessionStorage.getItem("token");

    if (token) {
      return token;
    }
  }
}